// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1nNov","label":"Radio_label__SfA7V","checkMark":"Radio_checkMark__1A9md","disabled":"Radio_disabled__R9S_h"};